import { type FunctionComponent } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu } from "antd";
import { useTranslation } from "react-i18next";

interface OwnProps {
  addScheduledMessages: () => void;
  addEmailAction: () => void;
  addSurveyAction: () => void;
  addPopUpAction: () => void;
  addTagsAction: () => void;
  addTeamMemberTask: () => void;
  addAiAgentMessage: () => void;
  addAiReport: () => void;
  addAssignHabits: () => void;
  addEnrollChallenge: () => void;
}

type Props = OwnProps;

const AddAutomationButton: FunctionComponent<Props> = ({
  addScheduledMessages,
  addEmailAction,
  addSurveyAction,
  addPopUpAction,
  addTagsAction,
  addTeamMemberTask,
  addAiAgentMessage,
  addAiReport,
  addAssignHabits,
  addEnrollChallenge,
}) => {
  const { t } = useTranslation(["automation", "dashboard"]);
  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={addScheduledMessages}>
        {t("addAutomationMessage")}
      </Menu.Item>
      <Menu.Item key="2" onClick={addEmailAction}>
        {t("programAutomation.addEmailAction")}
      </Menu.Item>
      <Menu.Item key="3" onClick={addSurveyAction}>
        {t("programAutomation.addSurveyAction")}
      </Menu.Item>
      <Menu.Item key="4" onClick={addPopUpAction}>
        {t("programAutomation.addPopUpAction")}
      </Menu.Item>
      <Menu.Item key="5" onClick={addTagsAction}>
        {t("programAutomation.addTagsAction")}
      </Menu.Item>
      <Menu.Item key="6" onClick={addTeamMemberTask}>
        {t("programAutomation.addTeamMemberTask")}
      </Menu.Item>
      <Menu.Item key="7" onClick={addAiAgentMessage}>
        {t("programAutomation.addAiAgentMessageAction")}
      </Menu.Item>
      <Menu.Item key="10" onClick={addAiReport}>
        {t("programAutomation.addAiReportAction")}
      </Menu.Item>
      <Menu.Item key="8" onClick={addAssignHabits}>
        Dodaj przypisanie nawyków
      </Menu.Item>
      <Menu.Item key="9" onClick={addEnrollChallenge}>
        Dodaj zapis do wyzwania
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["contextMenu", "click"]}>
      <div className="3s text-center opacity-0 transition-opacity hover:opacity-100">
        <Button type="link" icon={<PlusOutlined />}>
          {t("programAutomation.addButton")}
        </Button>
      </div>
    </Dropdown>
  );
};

export default AddAutomationButton;
